import { styled } from "@mui/material/styles";
import { Box, Typography, Button, Tabs, Tab } from "@mui/material";

export const ModalContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  width: "100%",
  [theme.breakpoints.down("sm")]: {
    padding: "0",
  },
}));

export const ModalTitle = styled(Typography)(({ theme }) => ({
  fontSize: "26px",
  fontWeight: 600,
  color: "#1B252F",
  textAlign: "center",
  marginBottom: "12px",
  [theme.breakpoints.down("sm")]: {
    fontSize: "20px",
  },
}));

export const ModalSubtitle = styled(Typography)(({ theme }) => ({
  fontSize: "16px",
  fontWeight: 400,
  color: theme.palette.text.secondary,
  textAlign: "center",
  marginBottom: "32px",
  fontFamily: "Nunito",
  [theme.breakpoints.down("sm")]: {
    fontSize: "14px",
    marginBottom: "24px",
  },
}));

export const StyledTabs = styled(Tabs)(({ theme }) => ({
  width: "100%",
  marginBottom: "24px",
  minHeight: "48px",
  "& .MuiTabs-indicator": {
    backgroundColor: theme.palette.primary.main,
    height: "3px",
    borderRadius: "3px 3px 0 0",
  },
  "& .MuiTabs-flexContainer": {
    gap: "8px",
  },
  [theme.breakpoints.down("sm")]: {
    marginBottom: "16px",
    minHeight: "40px",
  },
}));

export const StyledTab = styled(Tab)(({ theme }) => ({
  flex: 1,
  maxWidth: "none",
  padding: "12px 24px",
  fontSize: "14px",
  fontWeight: 600,
  textTransform: "none",
  color: theme.palette.text.primary,
  minHeight: "48px",
  "&.Mui-selected": {
    color: theme.palette.primary.main,
  },
  "&:hover": {
    color: theme.palette.primary.main,
    opacity: 1,
  },
  [theme.breakpoints.down("sm")]: {
    padding: "10px 12px",
    fontSize: "12px",
    minHeight: "40px",
  },
}));

export const SignatureContainer = styled(Box)(({ theme }) => ({
  width: "100%",
  marginBottom: "32px",
  [theme.breakpoints.down("sm")]: {
    marginBottom: "24px",
  },
}));

export const TypedSignatureContainer = styled(Box)(() => ({
  width: "100%",
  display: "flex",
  flexDirection: "column",
  gap: "16px",
}));

export const SignatureInput = styled("input")(({ theme }) => ({
  width: "100%",
  padding: "12px 16px",
  borderRadius: "8px",
  border: `1px solid ${theme.palette.border?.medium || "#E0E0E0"}`,
  backgroundColor: "#fff",
  fontSize: "14px",
  fontFamily: "Nunito",
  color: theme.palette.text.primary,
  outline: "none",
  transition: "border-color 0.2s",
  "&:focus": {
    borderColor: theme.palette.primary.main,
  },
  "&::placeholder": {
    color: theme.palette.text.secondary,
  },
  [theme.breakpoints.down("sm")]: {
    padding: "10px 12px",
    fontSize: "13px",
  },
}));

export const TypedSignaturePreview = styled(Box)(({ theme }) => ({
  width: "100%",
  height: "120px",
  padding: "16px",
  borderRadius: "8px",
  border: `1px solid ${theme.palette.border?.medium || "#E0E0E0"}`,
  backgroundColor: "#FAFAFA",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  [theme.breakpoints.down("sm")]: {
    height: "100px",
    padding: "12px",
  },
}));

export const SignatureText = styled(Typography)(({ theme }) => ({
  fontFamily: "'Dancing Script', cursive",
  fontSize: "36px",
  color: "#1B252F",
  fontWeight: 600,
  textAlign: "center",
  wordBreak: "break-word",
  [theme.breakpoints.down("sm")]: {
    fontSize: "24px",
  },
}));

export const CanvasContainer = styled(Box)(({ theme }) => ({
  width: "100%",
  height: "200px",
  borderRadius: "8px",
  border: `1px solid ${theme.palette.border?.medium || "#E0E0E0"}`,
  backgroundColor: "#fff",
  position: "relative",
  overflow: "hidden",
  [theme.breakpoints.down("sm")]: {
    height: "180px",
  },
}));

export const SignatureCanvas = styled("canvas")(() => ({
  width: "100%",
  height: "100%",
  cursor: "crosshair",
  touchAction: "none",
}));

export const ClearButton = styled(Button)(({ theme }) => ({
  position: "absolute",
  top: "8px",
  right: "8px",
  padding: "4px 12px",
  fontSize: "12px",
  textTransform: "none",
  color: theme.palette.text.secondary,
  "&:hover": {
    backgroundColor: theme.palette.action?.hover,
  },
}));

export const CanvasPlaceholder = styled(Typography)(({ theme }) => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  fontSize: "14px",
  color: theme.palette.text.secondary,
  pointerEvents: "none",
  textAlign: "center",
  [theme.breakpoints.down("sm")]: {
    fontSize: "12px",
  },
}));

export const ActionsContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  gap: "24px",
  width: "100%",
  justifyContent: "center",
  [theme.breakpoints.down("sm")]: {
    flexDirection: "column-reverse",
    gap: "12px",
  },
}));
